import React from 'react';

import { Ebay } from '@depop/web-thrift-ui/Icons/Ebay';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

type Props = {
  onClick?: () => void;
  disabled?: boolean;
};

export function EbayButton({ onClick, disabled }: Props) {
  const t = useTranslations('common');

  return (
    <button
      type="button"
      className={styles.ebayButton}
      onClick={onClick}
      disabled={disabled}
    >
      <span className={styles.icon}>
        <Ebay />
      </span>
      <span className={styles.label}>{t('EbaySSO.Button')}</span>
    </button>
  );
}
